import { Reducer } from 'redux';
import {
  IAnnealedWireType,
  IDiameter,
  IFabricationState,
  IPieceType,
  ISteelType,
  Types
} from './types';

const INITIAL_STATE: IFabricationState = {
  annealedWireTypesState: {
    loading: false,
    error: false,
    selectedContractNumber: undefined,
    wireTypes: undefined
  }
};

type CustomAction = {
  type: Types;
  payload: {
    pieceTypes: IPieceType[];
    steelTypes: ISteelType[];
    steelTypeId: number;
    diameters: IDiameter[];
    wireTypes: IAnnealedWireType[];
    selectedContractNumber: string;
  };
};

const reducer: Reducer<IFabricationState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    // TIPOS DE PEÇA
    case Types.LOAD_PIECE_TYPES:
      return {
        ...state,
        pieceTypesState: { loading: true, error: false, pieceTypes: [] }
      };
    case Types.LOAD_PIECE_TYPES_SUCCESS:
      return {
        ...state,
        pieceTypesState: {
          loading: false,
          error: false,
          pieceTypes: action.payload.pieceTypes
        }
      };
    case Types.LOAD_PIECE_TYPES_FAILURE:
      return {
        ...state,
        pieceTypesState: { loading: false, error: true, pieceTypes: [] }
      };

    // TIPOS DE AÇO
    case Types.LOAD_STEEL_TYPES:
      return {
        ...state,
        steelTypesState: { loading: true, error: false, steelTypes: [] }
      };
    case Types.LOAD_STEEL_TYPES_SUCCESS:
      return {
        ...state,
        steelTypesState: {
          loading: false,
          error: false,
          steelTypes: action.payload.steelTypes
        }
      };
    case Types.LOAD_STEEL_TYPES_FAILURE:
      return {
        ...state,
        steelTypesState: { loading: false, error: true, steelTypes: [] }
      };

    // BITOLA POR TIPO DE AÇO
    case Types.LOAD_STEEL_TYPE_DIAMETERS:
      return {
        ...state,
        steelTypesState: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...state.steelTypesState!,
          steelTypes: updateSteelTypeDiameterState(
            action.payload.steelTypeId,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            state.steelTypesState!.steelTypes,
            true,
            false,
            []
          )
        }
      };
    case Types.LOAD_STEEL_TYPE_DIAMETERS_SUCCESS:
      return {
        ...state,
        steelTypesState: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...state.steelTypesState!,
          steelTypes: updateSteelTypeDiameterState(
            action.payload.steelTypeId,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            state.steelTypesState!.steelTypes,
            false,
            false,
            action.payload.diameters
          )
        }
      };
    case Types.LOAD_STEEL_TYPE_DIAMETERS_FAILURE:
      return {
        ...state,
        steelTypesState: {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...state.steelTypesState!,
          steelTypes: updateSteelTypeDiameterState(
            action.payload.steelTypeId,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            state.steelTypesState!.steelTypes,
            false,
            true,
            []
          )
        }
      };

    // TIPOS DE AÇO
    case Types.LOAD_WIRE_TYPES:
      return {
        ...state,
        annealedWireTypesState: {
          selectedContractNumber: action.payload.selectedContractNumber,
          loading: true,
          error: false,
          wireTypes: []
        }
      };
    case Types.LOAD_WIRE_TYPES_SUCCESS:
      return {
        ...state,
        annealedWireTypesState: {
          ...(state.annealedWireTypesState || null),
          loading: false,
          error: false,
          wireTypes: action.payload.wireTypes
        }
      };
    case Types.LOAD_WIRE_TYPES_FAILURE:
      return {
        ...state,
        annealedWireTypesState: {
          ...(state.annealedWireTypesState || null),
          loading: false,
          error: true,
          wireTypes: []
        }
      };

    default:
      return state;
  }
};

const updateSteelTypeDiameterState = (
  steelTypeId: number,
  steelTypes: ISteelType[],
  loading: boolean,
  error: boolean,
  diameters: IDiameter[]
): ISteelType[] => {
  const selectedSteelTypeIdx = steelTypes.findIndex(
    (steelType) => steelType.id === steelTypeId
  );
  if (selectedSteelTypeIdx !== -1) {
    (steelTypes[selectedSteelTypeIdx] as ISteelType).diametersState = {
      ...(steelTypes[selectedSteelTypeIdx] as ISteelType).diametersState,
      diameters,
      loading,
      error
    };
  }

  return steelTypes;
};

export default reducer;
